import { Stack } from 'expo-router';

/** Avoid declaring this route on the root Stack (Expo Router v6 rejects unknown screen names there). */
export default function JoinCollaborationLayout() {
  return <Stack screenOptions={{ headerShown: false }} />;
}
